import { Component, EventEmitter, Input, Output, model } from '@angular/core';

export interface ChecklistItem {
    seccion: string;
    pregunta: string;
    preguntaId?: string; // UUID
    preguntaIdVisible?: number; // legacy numeric id
    respuesta?: 'OK' | 'REP' | 'NA';
    comentario?: string;
}

@Component({
    selector: 'app-checklist',
    templateUrl: './checklist.component.html',
    styleUrl: './checklist.component.scss',
    standalone: false
})
export class ChecklistComponent {
    @Input() titulo: string = 'Checklist';
    @Input() subtitle?: string;
    @Input() readOnly: boolean = false;
    @Input() commentPlaceholder: string = 'Si requiere escribir algún comentario.';
    @Input() mostrarNA: boolean = true;
    items = model<ChecklistItem[]>([]);

    @Output() completar = new EventEmitter<void>();

    setRespuesta(index: number, valor: 'OK' | 'REP' | 'NA') {
        if (this.readOnly) return;
        if (!this.items() || !this.items()[index]) return;
        this.items()[index].respuesta = valor;
    }

    completarChecklist() {
        // (podés validar que estén todos respondidos si querés)
        this.completar.emit();
    }
}
